import VisaoExecutivaView from "../../components/gestaoOrcamentaria/VisaoExecutivaView";

export default function VisaoExecutiva() {
  return <VisaoExecutivaView tituloModulo="Visão Executiva" />;
}
